import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import ColorUtil from '../utils/color';

require.ensure([], () => {  
    require('./PMO.less');
    require('./PMOProjectListWidget.less');
});

class ProjectPill extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            popoverTimeout: null,
            glyphVisible: false,
            glyphFocused: false
        };
    }

    // LIFECYCLE METHODS

    // EVENT HANDLERS

    handleClick = () => {
        if (!this.state.glyphFocused)
            this.props.handleFunction(this.props.id);
    }

    handleRemove = () => {
        this.props.handleRemove(this.props.id);
    }

    // OTHER METHODS

    showPopover = () => {
        if (this.refs.popoverTrigger)
            this.refs.popoverTrigger.show();
    }

    // RENDER METHOD

    render = () => {
        let color = this.props.project ? ColorUtil.RGBtoRGBA(this.props.project.defaultColor, 1.0) : "#FF0000";

        if (this.props.active) {
            return (
                <li className="active" style={{borderColor : color, wordWrap : "break-word"}}>
                    <a onClick={this.handleClick} style={{"cursor" : "pointer", backgroundColor : color, borderColor : color}}>{this.props.text}</a>
                </li>
            );
        } else {
            return (
                <li style={{borderColor : color, wordWrap : "break-word"}}>
                    <a onClick={this.handleClick} style={{"cursor" : "pointer" }}>{this.props.text}</a>
                </li>
            );
        }

    }
}

ProjectPill.propTypes = {
    active: PropTypes.bool,
    handleFunction: PropTypes.func,
    handleRemove: PropTypes.func,
    id: PropTypes.number,
    project: PropTypes.object,
    text: PropTypes.string
};

export default connect()(ProjectPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/ProjectPill.js
 **/